export enum ShopStatus {
  OFFLINE = 9999, // 9999 店铺下线
  OUT_OF_RANGE = 9998, // 9998 超出配送范围
  ONLINE = 3, // 3 店铺营业中
  CLOSED = 4, // 4 店铺休息中
}

// 埋点用
export const lxShopStatus = {
  open: 0,
  res: 1,
  offline: 2,
};
